import { Navigate, Route } from 'react-router-dom'

import { PinLoginPage } from '@/features/auth/PinLoginPage'
import { KitchenActivatePage } from '@/features/kitchen/ActivatePage'
import { KitchenAttendancePage } from '@/features/kitchen/AttendancePage'
import { KitchenDispatchPage } from '@/features/kitchen/DispatchPage'
import { KitchenHomePage } from '@/features/kitchen/HomePage'
import { KitchenEntryRedirect } from '@/features/kitchen/KitchenEntryRedirect'
import { KitchenTransferPage } from '@/features/kitchen/KitchenTransferPage'
import { KitchenProductionPage } from '@/features/kitchen/ProductionPage'
import { KitchenStockPage } from '@/features/kitchen/StockPage'
import { WarehouseReceivePage } from '@/features/kitchen/WarehouseReceivePage'
import { WarehouseReturnPage } from '@/features/kitchen/WarehouseReturnPage'
import { KitchenWastePage } from '@/features/kitchen/WastePage'
import { KitchenAppLayout } from '@/shared/layouts/KitchenAppLayout'
import { KitchenAuthLayout } from '@/shared/layouts/KitchenAuthLayout'

export const kitchenRouteElements = (
  <>
      <Route path="/kitchen/waste/proposal" element={<Navigate to="/kitchen/waste" replace />} />
      <Route path="/kitchen/waste/execute" element={<Navigate to="/kitchen/waste" replace />} />
      <Route path="/kitchen/returns" element={<Navigate to="/kitchen/home" replace />} />

      <Route path="/kitchen">
        <Route element={<KitchenAuthLayout />}>
          <Route index element={<KitchenEntryRedirect />} />
          <Route path="activate" element={<KitchenActivatePage />} />
          <Route
            path="login"
            element={
              <PinLoginPage redirectTo="/kitchen/home" requireDevice />
            }
          />
        </Route>
        <Route element={<KitchenAppLayout />}>
          <Route path="home" element={<KitchenHomePage />} />
          <Route path="production" element={<KitchenProductionPage />} />
          <Route path="dispatch" element={<KitchenDispatchPage />} />
          <Route path="waste" element={<KitchenWastePage />} />
          <Route path="attendance" element={<KitchenAttendancePage />} />
          <Route path="stock" element={<KitchenStockPage />} />
          <Route path="kitchen-transfer" element={<KitchenTransferPage initialTab="send" />} />
          <Route
            path="kitchen-transfer/receive"
            element={<KitchenTransferPage initialTab="receive" />}
          />
          <Route path="warehouse-receive" element={<WarehouseReceivePage />} />
          <Route path="warehouse-return" element={<WarehouseReturnPage />} />
        </Route>
      </Route>
  </>
)
